import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import { axios } from '@bundled-es-modules/axios';

export class LoginComponent extends LitElement {

  static get properties() {
    return {
      _username: { type: String },
      _password: { type: String },
      _MainServiceDomain: { type: String },
      _forgotPasswordLink: {type: String},

      _activationLink: { type: String },
      _registerLink: { type: String },

      errorMessage: { type: String },
      isSystemError: { type: String }
    }
  }

  get username() {
    return this._username;
  }

  set username(value) {
    this._username = value;
  }

  get password() {
    return this._password;
  }

  set password(value) {
    this._password = value;
  }

  get MainServiceDomain() {
    return this._MainServiceDomain;
  }

  set MainServiceDomain(value) {
    this._MainServiceDomain = value;
  }

  get forgotPasswordLink() {
    return this._forgotPasswordLink;
  }

  set forgotPasswordLink(value) {
    this._forgotPasswordLink = value;
  }

  get activationLink(){
    return this._activationLink;
  }
  set activationLink(value){
    this._activationLink = value;
  }

  get registerLink(){
    return this._registerLink;
  }
  set registerLink(value){
    this._registerLink = value;
  }

  constructor() {
    super();
    this.isSystemError = false;
  }

  static get styles() {
    return [
      css`
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
        .text-center {
          text-align: center !important;
      }
      
      .d-none {
          display: none;
      }
      
      .d-block {
          display: block;
      }
      
      .d-flex {
          display: flex;
      }
      
      .justify-content-between {
          justify-content: space-between;
      }
      
      .mg-b5 {
          margin-bottom: 5px !important;
      }

      .mg-b30 {
        margin-bottom: 30px !important;
      }
      
      .mg-t5 {
          margin-top: 5px !important;
      }
      
      p{
          font-size: 13px;
      }
      
      .font-bold {
          font-weight: 700;
      }
      
      .min-width95 {
          min-width: 95px;
      }
      
      .w100 {
          width: 100%;
      }
      
      .w-25 {
          width: 25%;
      }

      .w-75 {
          width: 75%;
      }

      /* Element Style */
      .login-box {
          margin: 0 auto;
          border-radius: 35px;
          position: relative;
          padding: 45px;
          border: 1px solid var(--w-bg-borc, #505050);
          background-color: var(--w-bgc, #fff);
          box-sizing: border-box;
      }
      
      .btn {
          display: inline-block;
          font-weight: 400;
          text-align: center;
          white-space: nowrap;
          vertical-align: middle;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          border: 1px solid transparent;
          padding: 6px 12px;
          font-size: 16;
          line-height: 1.5;
          border-radius: 4px;
      }
      
      .btn:hover, .btn:focus {
          text-decoration: none;
      }
        
      .btn:focus, .btn.focus {
          outline: 0;
          box-shadow: none;
      }
        
      .btn.disabled, .btn:disabled {
          opacity: 0.65;
      }

      .btn-success {
        color: var(--w-btn-col, #505050);
        background-color: var(--w-btn-bgc, #fff);
        border: 1px solid var(--w-btn-borc, #505050);
        font-size: var(--w-btn-fs, 14px);
        cursor: pointer;
      }
    
     .btn-success:hover {
        color: var(--w-btn-col, #fff);
        background-color: var(--w-btn-bgc, #505050);
        border: 1px solid var(--w-btn-borc, #505050);
        font-size: var(--w-btn-fs, 14px);
        cursor: pointer;
     }
    
     .btn-lg {
        padding: 8px 16px;
        font-size: var(--w-btn-fs, 14px);
        line-height: 1.5;
        border-radius: 4px;
     }
      
     .btn-block {
          display: block;
          width: 100%;
      }
      
      label {
          text-align: left;
          font-size: 13px;
          color: var(--label-color, #000);
      }
     
      .form-group {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 0;
        color: var(--form-group-color, #fff);
    }
    
    .form-control {
        display: block;
        width: 100%;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.5;
        color: var(--form-control-color, #000);
        background-color: var(--form-control-bgColor, #fff);
        background-clip: padding-box;
        border: 1px solid var(--form-control-borderColor, #000);
        border-radius: 4px;
    }
    
    .form-control:focus {
        color: var(--form-control-focus-color, #495057);
        background-color: var(--form-control-focus-bgColor, #fff);
        border-color: var(--form-control-borderColor, #80bdff);
        outline: 0;
        box-shadow: 0 0 0 0.2rem var(--form-control-focus-boxShadow, rgba(65, 157, 255, 0.25));
      }
    
      .form-control:hover {
        -webkit-appearance: none;
      }
    
    .form-control::-webkit-input-placeholder {
        color: var(--form-control-placehorderColor, #959595);
        opacity: 1;
    }
    
    .form-control::-moz-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
    }
    
    .form-control:-ms-input-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
    }
    
    .form-control::-ms-input-placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
    }
    
    .form-control::placeholder {
        color: var(--form-control-placeholderColor, #959595);
        opacity: 1;
    }

    .editable-field {
      background-color: var(--editonly-bgColor, #FFF);
      border: 1px solid #D3D7D9;
      color: var(--editonly-color, #000000);
      border-radius: 3px;
      pointer-events: all;
      visibility: visible;
    }
   .error {
     font-size: var(--w-msg-fs-login, 12px);
     color: var(--w-msg-col, #000);
   }

   .error-text-color {
     color: var(--w-err-sys-col, red);
   }`,
    ];
  }

  render() {
    return html
      `<div class="login-box">
      <h2 class="text-center mg-b30">Login</h2>
      <div class=${classMap({ 'text-center': true, 'mg-b30': true, 'error': true, 'error-text-color': this.isSystemError })}>${this.errorMessage}</div>
      <div class="d-block mg-b5">
          <div class="form-group mg-b5">
              <div class="w-25">
                  <label><strong>User Name</strong></label>
              </div>
              <div class="w-75">
                  <input type="text" id="username" name="username" class="form-control editable-field"
                  @input="${this.onInputUsername}">
              </div>
          </div>
          <div class="form-group mg-b5">
              <div class="w-25">
                  <label><strong>Password</strong></label>
              </div>
              <div class="w-75">
                  <input id="password" name="password" type="password" class="form-control editable-field"
                  @input="${this.onInputPasswword}">
              </div>
          </div>
          <div class="w-75" style="margin-left: auto;">
              <button id="login_btn" type="submit" .disabled=${!(this.username && this.password)} class="btn btn-success btn-lg w100 mg-t5" @click="${this.onLogin}">Login</button>
          </div>
          <div class="w-75 mg-t5" style="margin-left: auto;">
          <a .href=${this.forgotPasswordLink}>Forgot password?</a>
          </div>
          <p></p>
          <div style="text-align: center; margin-top:30px">
            <p>Existing print subscribers who need a login, <a .href=${this.activationLink}>click Here</a></p>
          </div>
          <div style="text-align: center; margin-top:10px">
            <p>Not a subscriber?  <a .href=${this.registerLink}>Click here to see our current offers</a></p>
          </div>

          </div>
  </div>`
  }

  onInputUsername() {
    this.isSystemError = false;
    this.errorMessage = "";
    this.username = this.shadowRoot.getElementById('username').value;
  }

  onInputPasswword() {
    this.isSystemError = false;
    this.errorMessage = "";
    this.password = this.shadowRoot.getElementById('password').value;
  }

  async onLogin() {
    try {
      this.isSystemError = false;
      this.errorMessage = "";
      const body = `grant_type=password&username=${encodeURIComponent(this.username)}&password=${encodeURIComponent(this.password)}`; const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }

      const res = await axios.post(`${this.MainServiceDomain}/appservices/token`, body, {
        headers: headers
      });

      if (res.data.access_token) {
        const loginDetails = Object.keys(res.data).map((key) => {
          if (key === 'access_token') {
            key = 'token';
            return { [key]: res.data['access_token'] };
          }
          return { [key]: res.data[key] };
        }).reduce((a, b) => Object.assign({}, a, b));

        document.cookie = "ls.authorizationData" + "=" + encodeURIComponent(JSON.stringify(loginDetails)) + ";path=/";
        this.dispatchEvent(new CustomEvent('onLoginSuccessEvent', {
          bubbles: true,
          composed: true,
        }));
      } else {
        this.errorMessage = "Something went wrong";
      }

    } catch (error) {
      if (error.response && error.response.data && error.response.status != 500) {
        if (error.response.data.error == "invalid_grant") {
          this.isSystemError = true;
          this.errorMessage = "Login failed! Either your email address or your password is incorrect.";
        } else {
          this.errorMessage = error.response.data.error_description;
        }
      } else {
        this.isSystemError = true;
        this.errorMessage = "System is temporarily unavailable, please try again later";
      }
      console.log(error.response);
    }
  }

}

customElements.define('syncui-login', LoginComponent);
